import { apiSlice } from "../../app/api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    login: builder.mutation({
      query: credentials => ({
        url: '/users/admin-login/',
        method: 'POST',
        body: { ...credentials }
      })
    }),
    forgotPassword: builder.mutation({
      query: (email) => ({
        url: '/users/forgot-password/',
        method: 'POST',
        body: { email }
      })
    }),
  })
});

export const { useLoginMutation, useForgotPasswordMutation } = authApiSlice;
